export default __webpack_public_path__ + "static/media/S10.ae33ee84.png";